import React, { useState } from 'react';
import MainLayout from '../components/MainLayout';
import { mainTable } from '../css/Common';
import InputText from '../ReusableComponents/InputText';
import ReportGridPage from '../components/ReportGridPage'; 
import { EnquirytobookingHeader } from '../components/HeaderAttribute';

const Enquirytobookingpercentage = () => {
  const [formFields, setFormFields] = useState({
    fromDate: '',
    toDate: '',
  });

  const [errors, setErrors] = useState({
    fromDate: '',
    toDate: ''
  });

  const [showTable, setShowTable] = useState(false);
  const [BindEnquirytobookingData, setBindEnquirytobookingData] = useState([

    {
      villaName: 'Golden Villa',
      enquirydate: '18-05-2025',
      bookingdate: '19-05-2025'
    }
  ]);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = '';

    if (value.trim() === '') {
      const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
      error = `Enter ${formattedName}`;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error
    }));
  };

  const GoButton = () => {
    let hasError = false;
    const newErrors = { fromDate: '', toDate: '' };

    if (!formFields.fromDate.trim()) {
      newErrors.fromDate = 'Enter From Date';
      hasError = true;
    }

    if (!formFields.toDate.trim()) {
      newErrors.toDate = 'Enter To Date';
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) return;

    console.log('From Date:', formFields.fromDate);
    console.log('To Date:', formFields.toDate);

    const dummyData = [
      {
        villaName: 'Golden Villa',
        villaTariff:'5000',
        enquirydate: '18-05-2025',
        bookingdate: '19-05-2025'
      },

      {
        villaName: ' Star Villa',
        villaTariff:'10000',
        enquirydate: '20-05-2025',
        bookingdate: '22-05-2025'
      },

      {
        villaName: ' Platinum',
        villaTariff:'10000',
        enquirydate: '20-05-2025',
        bookingdate: '24-05-2025'
      },

      
      {
        villaName: ' Star Villa',
        villaTariff:'10000',
        enquirydate: '20-05-2025',
        bookingdate: '22-05-2025'
      },
      
      {
        villaName: ' Star Villa',
        villaTariff:'10000',
        enquirydate: '20-05-2025',
        bookingdate: '22-05-2025'
      },
      
      {
        villaName: ' Star Villa',
        villaTariff:'10000',
        enquirydate: '20-05-2025',
        bookingdate: '22-05-2025'
      },
      
      {
        villaName: ' Star Villa',
        villaTariff:'10000',
        enquirydate: '20-05-2025',
        bookingdate: '22-05-2025'
      },
      
      {
        villaName: ' Star Villa',
        villaTariff:'10000',
        enquirydate: '20-05-2025',
        bookingdate: '22-05-2025'
      },


    ];
     
    setBindEnquirytobookingData(dummyData);
    setShowTable(true); 
  };

  const handleExport = () => {
    console.log('Export clicked');
  };

  const downloadPDF = () => {
    // PDF download logic
  };

  return (
    <MainLayout pageName={"4"}>
      <div className="relative m-3 bg-white rounded-lg">
        <div className={mainTable.headerTitle}>
          <div className="my-2 mx-12 md:grid gap-4 mb-6 md:grid-cols-2 sm:col-span-1 lg:mx-0">
            Enquiry to Booking Report
          </div>
          
          <div className={mainTable.grid3}>
            <InputText
              inputType="date"
              title="From Date"
              classStar="text-red-500"
              name="fromDate"
              disabled={false}
              content={formFields.fromDate}
              controlFunc={(e) =>
                setFormFields({ ...formFields, fromDate: e.target.value })
              }
              controlFuncBlur={handleBlur}
              errorMessage={errors.fromDate}
              inputClassName="w-full"
            />

            <InputText
              inputType="date"
              title="To Date"
              classStar="text-red-500"
              name="toDate"
              disabled={false}
              content={formFields.toDate}
              controlFunc={(e) =>
                setFormFields({ ...formFields, toDate: e.target.value })
              }
              controlFuncBlur={handleBlur}
              errorMessage={errors.toDate}
              inputClassName="w-full"
            />
            
            <div className="flex justify-start items-center mt-7 mb-6">
              <button
                type="button"
                onClick={GoButton}
                className={mainTable.addButton}
              >
                GO
              </button>
            </div>
          </div>
        </div>
        
        {showTable && (
          BindEnquirytobookingData.length > 0 ? (
            
              <ReportGridPage
                header={EnquirytobookingHeader}
                records={BindEnquirytobookingData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
                xScroll={"max-md:w-fit w-fit w-full"}
              />
            
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          )
        )}
      </div>
    </MainLayout>
  );
};

export default Enquirytobookingpercentage;